import { Flags } from '@pushly/aquarium-utils/lib/enums/flags'
import { InsightsDropdownGroup, TypeDropdownOption } from '../types'
import { FEAT_APP_MESSAGES, FEAT_LIVE_ACTIVITIES } from '../../../constants'
import { ReportConfigurationType } from '../enums/report-configuration-type'
import { ensureDomain } from '../helpers/conditions'
import { PlatformLevel } from '../enums/platform-level'

export const DEFAULT_TYPE: { value: ReportConfigurationType; label: string } = {
    value: ReportConfigurationType.DELIVERY,
    label: 'Notification Report',
}

export const TYPE_DROPDOWN_OPTIONS: InsightsDropdownGroup<TypeDropdownOption>[] = [
    {
        label: 'New',
        options: [
            { value: ReportConfigurationType.DELIVERY, label: 'Notification Report' },
            { value: ReportConfigurationType.SUBSCRIBER, label: 'Acquisition Report' },
            {
                value: ReportConfigurationType.APP_MESSAGE,
                label: 'App Message Report',
                condition: (opts) => ensureDomain(opts) && (opts.domain.flags?.includes(FEAT_APP_MESSAGES) ?? false),
            },
            {
                value: ReportConfigurationType.LIVE_ACTIVITY,
                label: 'Live Activity Report',
                condition: (opts) => ensureDomain(opts) && (opts.domain.flags?.includes(FEAT_LIVE_ACTIVITIES) ?? false),
            },
            {
                value: ReportConfigurationType.MONTHLY_UNIQUES,
                label: 'Uniques Report',
                condition: ensureDomain,
            },
            {
                value: ReportConfigurationType.PUB_NETWORK,
                label: 'Publisher Network Report',
                condition: (opts) =>
                    ensureDomain(opts) &&
                    (opts.domain.flags?.includes(Flags.domain.FEAT_DOMAIN_INTEGRATIONS_PUB_NETWORK.key) ?? false),
            },
        ],
    },
]
